<lib-panel-layout>
  <div class="flex flex-col items-stretch w-full min-w-0 gap-2">
    <div class="flex flex-col w-full min-w-0 gap-1.5">
      <div class="flex flex-col w-full min-w-0 gap-1.5">
        <lib-number-input
          class="min-w-0"
          [label]="'EDITOR.ANIMATION.WIDTH' | translate"
          [value]="width"
          [min]="1"
          [max]="maxAnimationSize"
          (changed)="onWidthChanged($event)"
          unit="px">
        </lib-number-input>
        <lib-number-input
          class="min-w-0"
          [label]="'EDITOR.ANIMATION.HEIGHT' | translate"
          [value]="height"
          [min]="1"
          [max]="maxAnimationSize"
          (changed)="onHeightChanged($event)"
          unit="px">
        </lib-number-input>
      </div>

      <div class="flex flex-col w-full min-w-0 gap-1.5">
        <lib-number-input
          class="min-w-0"
          [label]="'EDITOR.ANIMATION.LOOP_COUNT' | translate"
          [value]="loopCount"
          [min]="0"
          [max]="maxLoopCount"
          (changed)="onLoopCountChanged($event)">
        </lib-number-input>
      </div>

      <lib-checkbox
        class="min-w-0"
        [label]="'EDITOR.ANIMATION.TRANSPARENT_BACKGROUND' | translate"
        [checked]="useTransparentBackground"
        (changed)="onTransparentBackgroundChanged($event)">
      </lib-checkbox>

      <div class="flex flex-col w-full min-w-0 gap-1.5">
        <lib-color-picker
          class="min-w-0"
          [label]="'EDITOR.ANIMATION.BACKGROUND_COLOR' | translate"
          [value]="backgroundColor"
          [transparent]="useTransparentBackground"
          [displayValue]="useTransparentBackground ? ('EDITOR.ANIMATION.TRANSPARENT' | translate) : undefined"
          (changed)="onBackgroundColorChanged($event)">
        </lib-color-picker>
      </div>
    </div>
  </div>

  <lib-apply-panel
    panelActions
    class="w-full"
    [applyDisabled]="!canApply"
    (apply)="onApply()"
    (cancelRequested)="onCancel()">
  </lib-apply-panel>
</lib-panel-layout>
